import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AufgabeEintragDto } from "@app/dto/aufgabe.eintrag.dto";
import { AufgabeErledigtDto } from "@app/dto/aufgabe.erledigt.dto";
import { environment } from "@environments/environment";
import { Observable } from "rxjs";
import {VorschlagDuplikatDto} from "@app/dto/vorschlagduplikat.dto";
import {AufgabeDto} from "@app/dto/aufgabe.dto";
import {VorschlagEswDto} from "@app/dto/vorschlagEsw.dto";
import {DatePipe} from "@angular/common";

@Injectable({
    providedIn: 'root'
})
export class AufgabenService {
    private _baseUrl = `${environment.apiHost}/${environment.apiBaseUrl}`;

    currentAufgabe: AufgabeEintragDto = {
        id:                     "",
        aufgabeText:            "",
        datum:                  null,
        realDate:               null,
        adaIstSicher:           false,
        vertrauensIndikator:    0,
        aufgabenTyp:            "",
        erledigtVon:            "",
        erledigtAm:             "",
        pcAdressnummer:         0,
        firmenname:             "",
        strasseUndHausnummer:   "",
        plz:                    "",
        ort:                    "",
        laendercode:            "",
        nlCode:                 0,
        aufgabenpakete:         [],
        original:               null,
        azureSearchOriginal:    [],
        azureSearchESW:         [],
        ESW:                    []
    };

    public constructor(
        private readonly http: HttpClient,
        public datePipe: DatePipe
    ) { }

    public getAufgabenList(filter: string, take: number): Observable<{ anzahlBasierendAufFilter: number, aufgabenAsJsonString: string }> {
        const skip:number = 0;
        return this.http.get<{ anzahlBasierendAufFilter: number, aufgabenAsJsonString: string }>(`${this._baseUrl}/aufgaben/duplikatspruefung/offen`, { params: { filter, take, skip } });
    }

    public getESWList(filter: string): Observable<[]> {
        return this.http.get<[]>(`${this._baseUrl}/aufgaben/ESWLookup?maxcount=100${filter}`, {});
    }

    public markAsResolved(aufgabeErledigt: AufgabeErledigtDto): Observable<string> {
        return this.http.put<string>(`${this._baseUrl}/aufgaben`, aufgabeErledigt);
    }

    public reformatAufgabe(aufgabe: AufgabeDto): AufgabeEintragDto {
        // Vorschläge mit MatchingCode X rausfiltern
        let filteredVorschlaege: VorschlagDuplikatDto[] = [];
        if (Array.isArray(aufgabe.azureSearchOriginal)) {
            for (const vorschlag of aufgabe.azureSearchOriginal) {
                if (vorschlag.matchingCode !== 'X' && vorschlag.matchingCode !== 'BA' && vorschlag.matchingCode !== 'BB') {
                    if (aufgabe.aufgabenpakete[0].firmenstandort.laendercode) {
                        vorschlag.laendercode = aufgabe.aufgabenpakete[0].firmenstandort.laendercode;
                    }
                    filteredVorschlaege.push(vorschlag);
                }
            }
            aufgabe.azureSearchOriginal = filteredVorschlaege;
        } else {
            aufgabe.azureSearchOriginal = [];
        }

        if (aufgabe.azureSearchESW) {
            filteredVorschlaege = [];
            for (const vorschlag of aufgabe.azureSearchESW) {
                if (vorschlag.matchingCode !== 'X' && vorschlag.matchingCode !== 'BA' && vorschlag.matchingCode !== 'BB') {
                    if (aufgabe.aufgabenpakete[0].firmenstandort.laendercode) {
                        vorschlag.laendercode = aufgabe.aufgabenpakete[0].firmenstandort.laendercode;
                    }
                    filteredVorschlaege.push(vorschlag);
                }
            }
            aufgabe.azureSearchESW = filteredVorschlaege;
        }

        let filteredESWVorschlaege:VorschlagEswDto[] = [];
        let usedCrefoNums:Array<number> = [];
        let usedZips:Array<string>      = [];
        let usedCities:Array<string>    = [];
        if (aufgabe.ESW) {
            filteredESWVorschlaege = [];
            for (const vorschlag of aufgabe.ESW) {
                if ( ! usedCrefoNums.includes(Number(vorschlag.crefonummer)) &&  ! usedZips.includes(vorschlag.plz) && ! usedCities.includes(vorschlag.ort)) {
                    if (vorschlag.land) {
                        vorschlag.laendercode = vorschlag.land
                    }
                    else if (aufgabe.aufgabenpakete[0].firmenstandort.laendercode) {
                        vorschlag.laendercode = aufgabe.aufgabenpakete[0].firmenstandort.laendercode;
                    }
                    filteredESWVorschlaege.push(vorschlag);
                    if (vorschlag.crefonummer) {
                        usedCrefoNums.push(Number(vorschlag.crefonummer));
                    }
                    usedZips.push(vorschlag.plz);
                    usedCities.push(vorschlag.ort);
                }
            }
            aufgabe.ESW = filteredESWVorschlaege;
        }

        if ( ! aufgabe.azureSearchOriginal) {
            aufgabe.azureSearchOriginal = [];
        }
        if ( ! aufgabe.azureSearchESW) {
            aufgabe.azureSearchESW = [];
        }
        if ( ! aufgabe.ESW) {
            aufgabe.ESW = [];
        }

        aufgabe.aufgabeText = '';
        if (aufgabe.azureSearchESW.length > 0 || aufgabe.azureSearchOriginal.length > 0 || aufgabe.ESW.length > 0) {
            aufgabe.aufgabeText = 'Neuen Standort auf Übereinstimmung mit '

            if (aufgabe.azureSearchESW.length > 0 || aufgabe.azureSearchOriginal.length > 0) {
                aufgabe.aufgabeText += 'internen Vorschlägen ';
                if (aufgabe.ESW.length > 0) {
                    aufgabe.aufgabeText += 'und ';
                }
            }
            if (aufgabe.ESW.length > 0) {
                aufgabe.aufgabeText += 'ESW-Vorschlägen ';
            }
            aufgabe.aufgabeText += 'prüfen'

        } else {
            aufgabe.aufgabeText = 'Neuen Standort erzeugen';
        }

        return {
            id:                   aufgabe.id,
            datum:                aufgabe._ts ? this.datePipe.transform(aufgabe._ts * 1000, 'dd.MM.yyyy') : null,
            realDate:             new Date(aufgabe._ts * 1000),
            pcAdressnummer:       aufgabe.original.pcAdressnummer,
            salesforceId:         aufgabe.original.salesforceId ? aufgabe.original.salesforceId : undefined,
            firmenname:           aufgabe.aufgabenpakete[0].pcAdresse?.originalFirmenname ?? aufgabe.original.name,
            strasseUndHausnummer: aufgabe.original.strasseUndHausnummer,
            plz:                  aufgabe.original.plz,
            ort:                  aufgabe.original.ort,
            laendercode:          aufgabe.aufgabenpakete[0].firmenstandort.laendercode,
            nlCode:               aufgabe.original.nlCode,
            aufgabenpakete:       aufgabe.aufgabenpakete,
            adaIstSicher:         aufgabe.adaIstSicher,
            vertrauensIndikator:  aufgabe.vertrauensIndikator,
            aufgabenTyp:          aufgabe.aufgabenTyp,
            erledigtVon:          aufgabe.erledigtVon,
            erledigtAm:           aufgabe.erledigtAm,
            aufgabeText:          aufgabe.aufgabeText,
            azureSearchOriginal:  aufgabe.azureSearchOriginal,
            azureSearchESW:       aufgabe.azureSearchESW,
            original:             aufgabe.original,
            ESW:                  aufgabe.ESW
        }
    }
}